import { render } from "./DFab.vue?vue&type=template&id=3e430768&scoped=true"
import script from "./DFab.vue?vue&type=script&lang=js"
export * from "./DFab.vue?vue&type=script&lang=js"

import "./DFab.vue?vue&type=style&index=0&id=3e430768&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e430768"]])

export default __exports__